import React from 'react';
import { Facebook } from 'lucide-react';
import { contactInfo } from '../mock';
import { useLanguage } from '../LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  
  return (
    <footer className="bg-brand-bg py-20 text-center border-t border-brand-border">
      <div className="max-w-[900px] mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Visit Us */}
          <div>
            <h4 className="text-xs uppercase text-brand-secondary mb-4 font-medium tracking-wider">{t('contact.visitUs')}</h4>
            <p className="text-base font-medium text-brand-text leading-relaxed">
              {contactInfo.address}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase text-brand-secondary mb-4 font-medium tracking-wider">{t('contact.callUs')}</h4>
            <p className="text-base font-medium text-brand-text">
              <a href={`mailto:${contactInfo.email}`} className="hover:text-brand-accent transition-colors">
                {contactInfo.email}
              </a>
              <br />
              <a href={`tel:${contactInfo.phone}`} className="hover:text-brand-accent transition-colors" dir="ltr">
                {contactInfo.phone}
              </a>
            </p>
          </div>

          {/* Availability */}
          <div>
            <h4 className="text-xs uppercase text-brand-secondary mb-4 font-medium tracking-wider">{t('contact.workingHours')}</h4>
            <span className="inline-block bg-brand-blue px-4 py-1.5 rounded-full text-sm font-bold text-brand-text" dir="ltr">
              {language === 'ar' ? 'السبت – الأربعاء: 10:00 ص – 4:00 م' : 'Sat – Wed: 10:00 AM – 4:00 PM'}
            </span>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-4 mb-6">
          <a 
            href="https://www.facebook.com/profile.php?id=61586320313466&__tn__=-UC*F" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 bg-[#1877F2] rounded-full flex items-center justify-center text-white hover:opacity-80 transition-opacity"
            aria-label="Facebook"
          >
            <Facebook size={20} />
          </a>
        </div>

        <p className="text-xs text-brand-secondary mt-8">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
